import { isPlatformBrowser, NgClass, NgIf, NgStyle } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { ScreenSizeService } from '@Shared/services';
import { Galleria, GalleriaModule } from 'primeng/galleria';
import { LoaderService } from '@Shared/components/loader/loader.service';
import { BusinessService } from '@App/common/services';
import { TooltipModule } from 'primeng/tooltip';
import { NgxDocViewerModule } from 'ngx-doc-viewer';

@Component({
  selector: 'app-photo-galleria',
  templateUrl: './photo-galleria.component.html',
  styleUrls: ['./photo-galleria.component.scss'],
  standalone: true,
  imports: [
    GalleriaModule,
    NgxDocViewerModule,
    TooltipModule,
    NgClass,
    NgStyle,
    NgIf
  ]
})
export class PhotoGalleriaComponent implements OnInit, OnChanges, OnDestroy {
  isMobile: boolean;
  isDesktop: boolean;

  @Input() images: string[] | { file: string; thumbnail: string }[] = [];
  @Input() showGalleria: boolean;
  @Input() showThumbnails = true;
  @Input() activeIndex: number = 0;
  @Output() hideGallery = new EventEmitter<boolean>();

  @ViewChild('galleria', { static: true }) galleria: Galleria;

  private maskMoved = false;
  private maskHost: HTMLElement | null = null;

  constructor(
    private screenSizeService: ScreenSizeService,
    private loaderService: LoaderService,
    private businessService: BusinessService,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  @HostListener('window:click', ['$event'])
  handleClick(event: any) {
    const path = event.path || (event.composedPath && event.composedPath());

    if (
      path?.find((x) =>
        path?.find(
          (x) =>
            x?.className &&
            x?.className?.includes &&
            x?.className?.includes('p-galleria-close')
        )
      )
    ) {
      this.onGalleriaHide();
    }
  }

  ngOnInit() {
    this.isMobile = this.screenSizeService.isMobile;
    this.isDesktop = this.screenSizeService.isDesktop;
    this.setupLoader(true);
    this.setupHeader();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes['showGalleria']) {
      return;
    }

    if (this.showGalleria) {
      setTimeout(() => this.attachMaskToBody());
    } else {
      this.restoreMask();
    }
  }

  ngOnDestroy() {
    this.restoreMask();
    this.setupLoader(false);
    this.images = [];
  }

  private attachMaskToBody() {
    if (!isPlatformBrowser(this.platformId) || !this.showGalleria || this.maskMoved) {
      return;
    }

    const mask = this.galleria?.mask?.nativeElement as HTMLElement | undefined;
    if (!mask || mask.parentElement === document.body) {
      return;
    }

    this.maskHost = mask.parentElement;
    this.renderer.appendChild(document.body, mask);
    this.maskMoved = true;
  }

  private restoreMask() {
    if (!this.maskMoved) {
      return;
    }

    const mask = this.galleria?.mask?.nativeElement as HTMLElement | undefined;
    if (mask && this.maskHost) {
      this.renderer.appendChild(this.maskHost, mask);
    }

    this.maskMoved = false;
    this.maskHost = null;
  }

  onGalleriaHide() {
    this.setupHeader(true);
    this.hideGallery.emit(false);
  }

  isDocument(fileUrl) {
    if (fileUrl) {
      return (
        fileUrl.includes('.pdf') ||
        fileUrl.includes('.doc') ||
        fileUrl.includes('.docx')
      );
    } else {
      this.setupLoader(false);
      return false;
    }
  }

  getFilePreviewSrc(url: string) {
    if (url?.includes('.doc') || url?.includes('.docx')) {
      return '/assets/images/fa-icons/word-file.svg';
    } else if (url?.includes('.pdf')) {
      return '/assets/images/fa-icons/pdf-file.svg';
    } else {
      return url;
    }
  }

  updateCloseBtnStyle(isChange?) {
    if (isChange) {
      this.galleria.element.nativeElement.classList.remove('doc-viewer');
    } else {
      this.galleria.element.nativeElement.classList.add('doc-viewer');
    }
  }

  setupLoader(isLoading, item?) {
    // isLoading ? this.loaderService.show() : this.loaderService.hide();
  }

  setupHeader(show = false) {
    // if (this.isMobile) {
    //   const header = document.getElementById('header-container');
    //   console.log('header', header, show);
    //   if (!show) {
    //     header?.classList?.add('hidden');
    //   } else {
    //     header?.classList?.remove('hidden');
    //   }
    // }
  }

  setGalleryNavigation(isLoading) {
    if (this.images?.length > 0) {
      // this.galleria.showItemNavigators = !isLoading;
    }
  }

  downloadFile(data) {
    if (!this.isDocument(data)) {
      this.businessService.downloadImage(data);
    } else {
      this.businessService.downloadImage(data, 'document');
    }
  }
}
